/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {SettlementAcceptCommentComponent} from './settlement-accept-comment.component';

@NgModule({
    declarations: [SettlementAcceptCommentComponent],
    imports: [
        CommonModule,
        PipesModule
    ],
    exports: [
        SettlementAcceptCommentComponent
    ]
})
export class SettlementAcceptCommentModule {
}
